var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',{staticClass:"alert alert-flashy z-20",class:_vm.alertClass},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.body))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }